<template>
  <b-table-simple
    bordered
    responsive
    sticky-header
    style="max-height: 65vh; font-size: 12px"
  >
    <colgroup>
      <col style="width: 90px">
      <col style="width: 120px">
      <col style="width: 250px">
      <col style="width: 130px">
      <col style="width: 130px">
      <col style="width: 120px">
      <col style="width: 150px">
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 120px">
      <!-- 메인 간편처방등록 -->
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <!-- 메인 텍스트배너 -->
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <!-- 처방팝업 -->
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <!-- 진료후팝업 -->
      <col style="width: 160px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 110px">
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 130px">
    </colgroup>
    <b-thead head-variant="light">
      <b-tr>
        <b-th rowspan="2">ID</b-th>
        <b-th rowspan="2">제약사</b-th>
        <b-th rowspan="2">제품명</b-th>
        <b-th rowspan="2">청구코드</b-th>
        <b-th rowspan="2">지역</b-th>
        <b-th rowspan="2">게시 기간</b-th>
        <b-th rowspan="2">진료과</b-th>

        <b-th rowspan="2">{{ searchType === 2 ? '전체처수' : '전체수' }}</b-th>
        <b-th rowspan="2">{{ searchType === 2 ? '요양기관수' : '의사수' }}</b-th>
        <b-th rowspan="2">{{ searchType === 2 ? '기등록처수' : '기등록수' }}</b-th>

        <b-th rowspan="2" v-html="searchType === 2 ? '노출처수<br/>(닥터인포)' : '노출수<br/>(닥터인포)'"></b-th>

        <b-th colspan="3">메인 간편처방등록</b-th>
        <b-th colspan="3">메인 텍스트배너</b-th>
        <b-th colspan="5">처방팝업</b-th>
        <b-th colspan="6">진료후팝업</b-th>

        <b-th rowspan="2" v-html="searchType === 2 ? '등록처수<br/>(기초자료)' : '등록수<br/>(기초자료)'"></b-th>
        <b-th rowspan="2">{{ searchType === 2 ? '잔여처수' : '잔여수' }}</b-th>

        <b-th rowspan="2">게시 잔여기간</b-th>
      </b-tr>
      <b-tr>
        <!-- 메인 간편처방등록 -->
        <b-th style="top: 38.55px">클릭수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '클릭처수' : '클릭명수' }}</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '등록처수' : '등록명수' }}</b-th>
        <!-- 메인 텍스트배너 -->
        <b-th style="top: 38.55px">클릭수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '클릭처수' : '클릭명수' }}</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '등록처수' : '등록명수' }}</b-th>
        <!-- 처방팝업 -->
        <b-th style="top: 38.55px">노출수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '노출처수' : '노출명수' }}</b-th>
        <b-th style="top: 38.55px">클릭수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '클릭처수' : '클릭명수' }}</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '등록처수' : '등록명수' }}</b-th>
        <!-- 진료후팝업 -->
        <b-th style="top: 38.55px">노출 기간</b-th>
        <b-th style="top: 38.55px">노출수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '노출처수' : '노출명수' }}</b-th>
        <b-th style="top: 38.55px">클릭수</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '클릭처수' : '클릭명수' }}</b-th>
        <b-th style="top: 38.55px">{{ searchType === 2 ? '등록처수' : '등록명수' }}</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <template v-for="daily in data">
        <template v-for="(dept, index) in daily.landingDepts">
          <b-tr
            :key="`daily-${daily.liveInfoId}-${daily.regionName}-${daily.execDate}-${index}`"
            :style="daily.region === 9999 ? 'background-color: rgba(127, 127, 255, 0.1);' : ''"
          >
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.liveInfoId }}
            </b-td>
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.clientName }}
            </b-td>
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.drugName }}
            </b-td>
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.cgCode }}
            </b-td>
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.regionName }}
            </b-td>
            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length + 1">
              {{ daily.execDate | $dateFormatter('MM월 DD일') }}
            </b-td>
            <b-td>{{ dept.medicalDeptName }}</b-td>

            <b-td>{{ dept.wasRegCount + dept.unRegCountDr | $numberFormatter }} </b-td>
            <b-td>{{ dept.uniqueCount | $numberFormatter }}</b-td>
            <b-td>{{ dept.wasRegCount | $numberFormatter }}</b-td>
            <b-td>{{ dept.unRegCountDr | $numberFormatter }}</b-td>

            <b-td>{{ dept.totalClickCountDr | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupClickCountDr | $numberFormatter }} </b-td>
            <b-td>{{ dept.landingRegCountDr | $numberFormatter }} </b-td>

            <b-td>{{ dept.totalClickCountTextBn | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupClickCountTextBn | $numberFormatter }} </b-td>
            <b-td>{{ dept.landingRegCountTextBn | $numberFormatter }} </b-td>

            <b-td>{{ dept.totalShowCountPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupShowCountPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.totalClickCountPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupClickCountPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.landingRegCountPopup | $numberFormatter }} </b-td>

            <b-td>{{ dept.afterConsultPopupPeriod }}</b-td>
            <b-td>{{ dept.totalShowCountAfterConsultPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupShowCountAfterConsultPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.totalClickCountAfterConsultPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.groupClickCountAfterConsultPopup | $numberFormatter }} </b-td>
            <b-td>{{ dept.landingRegCountAfterConsultPopup | $numberFormatter }} </b-td>

            <b-td>{{ dept.ysrRegCount | $numberFormatter }} </b-td>
            <b-td>{{ dept.unRegCountDr - (dept.landingRegCountDr + dept.landingRegCountTextBn + dept.landingRegCountPopup + dept.landingRegCountAfterConsultPopup + dept.ysrRegCount) | $numberFormatter }} </b-td>

            <b-td v-if="index === 0" :rowspan="daily.landingDepts.length ">
              {{ getRemainDate(daily.endDateStr)+'일' }}
            </b-td>
          </b-tr>
        </template>
        <b-tr
          :key="`daily-${daily.liveInfoId}-${daily.regionName}-${daily.execDate}-subtotal`"
          :style="daily.subTotal.medicalDeptName === '소계' ? 'background-color: rgba(127, 127, 127, 0.1);' : ''"
        >
          <b-td>{{ daily.subTotal.medicalDeptName }}</b-td>

          <b-td>{{ daily.subTotal.wasRegCount + daily.subTotal.unRegCountDr | $numberFormatter }}</b-td>
          <b-td>{{ daily.subTotal.uniqueCount | $numberFormatter }}</b-td>
          <b-td>{{ daily.subTotal.wasRegCount | $numberFormatter }}</b-td>
          <b-td>{{ daily.subTotal.unRegCountDr | $numberFormatter }} </b-td>

          <b-td>{{ daily.subTotal.totalClickCountDr | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupClickCountDr | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.landingRegCountDr | $numberFormatter }} </b-td>

          <b-td>{{ daily.subTotal.totalClickCountTextBn | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupClickCountTextBn | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.landingRegCountTextBn | $numberFormatter }} </b-td>

          <b-td>{{ daily.subTotal.totalShowCountPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupShowCountPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.totalClickCountPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupClickCountPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.landingRegCountPopup | $numberFormatter }} </b-td>

          <b-td></b-td>
          <b-td>{{ daily.subTotal.totalShowCountAfterConsultPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupShowCountAfterConsultPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.totalClickCountAfterConsultPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.groupClickCountAfterConsultPopup | $numberFormatter }} </b-td>
          <b-td>{{ daily.subTotal.landingRegCountAfterConsultPopup | $numberFormatter }} </b-td>

          <b-td>{{ daily.subTotal.ysrRegCount | $numberFormatter }} </b-td>

          <b-td>{{ daily.subTotal.unRegCountDr - (daily.subTotal.landingRegCountDr + daily.subTotal.landingRegCountTextBn + daily.subTotal.landingRegCountPopup + daily.subTotal.landingRegCountAfterConsultPopup + daily.subTotal.ysrRegCount) | $numberFormatter }} </b-td>

          <b-td></b-td>
        </b-tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'
import { onMounted } from '@vue/composition-api'
import dayjs from 'dayjs'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    searchType: {
      type: Number,
      required: true,
    },
  },
  setup() {
    onMounted(() => {
    })

    const getRemainDate = toDateStr => {
      const todayDate = dayjs()
      const result = dayjs(toDateStr).diff(todayDate, 'day') + 1
      if (result > 0) { return result }
      return 0
    }

    return {
      getRemainDate,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th, td {
  vertical-align: middle;
  text-align: center;
}
</style>
